import React, { ReactNode } from 'react';
import Avatar from 'src/components/Avatar';
import SrDetailContact from 'src/pages/ServiceRequest/components/SrDetailContact/SrDetailContact';
import calcomLogo from '../../calcom-logo.svg';
import './calcom-host-card.scss';

interface ICalcomHostCardProps {
  heading: string;
  lead: ReactNode;
  name?: string;
  email?: string;
  role?: string;
  isError?: boolean;
}

const CalcomHostCard = ({
  heading,
  lead,
  name,
  email,
  role = 'Cal.com host',
  isError = false,
}: ICalcomHostCardProps) => {
  const className: string = isError
    ? 'calcom-host-card calcom-host-card-error'
    : 'calcom-host-card';

  return (
    <div className={className}>
      <div className="calcom-host-card-header">
        <p className="calcom-host-card-heading">{heading}</p>
        <img className="calcom-host-card-logo" src={calcomLogo} alt="Cal.com" />
      </div>

      <p className="calcom-host-card-lead">{lead}</p>

      {name && (
        <SrDetailContact
          name={name}
          role={role}
          email={email}
          avatar={<Avatar url={null} badge={undefined} size={undefined} />}
        />
      )}
    </div>
  );
};

export default CalcomHostCard;